import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

const COOKIE_CONTROL_LOCALES = [
	'en-US',
	'en-GB',
	'de-DE',
	'es-ES',
	'fr-FR',
	'it-IT',
	'pt-PT',
]

export const useShowCookieControl = (): boolean => {
	const [showCookieControl, setShowCookieControl] = useState(false)
	const { locale } = useRouter()

	useEffect(() => {
		setShowCookieControl(COOKIE_CONTROL_LOCALES.includes(locale))
	}, [locale])

	return showCookieControl
}
